export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Long: { input: any; output: any };
};

export type AccessRack = {
  __typename?: 'AccessRack';
  /**   Play or Resume CTA */
  primaryCtaLabel?: Maybe<Scalars['String']['output']>;
  secondaryCtaAction?: Maybe<LockedCtaAction>;
  /**   Sign in, Subscribe or Ways to Watch CTA */
  secondaryCtaLabel?: Maybe<Scalars['String']['output']>;
  /**   true only if MediaMetadata.bookmark.locked = false (for auth and unauth users) */
  showPrimaryCta: Scalars['Boolean']['output'];
  /**   true if atleast one content in MediaMetadata is locked (for auth and unauth users). */
  showSecondaryCta: Scalars['Boolean']['output'];
};

/**   Describes the id and type of advertisement that is placed on a screen. */
export type AdElement = PresentationElement & {
  __typename?: 'AdElement';
  /**   Type of ad that is placed. Can be BigBox or Leaderboard. */
  adType: AdType;
  id: Scalars['String']['output'];
};

export enum AdType {
  Bigbox = 'BIGBOX',
  Leaderboard = 'LEADERBOARD',
}

/**   Describes the entry point to the application and allows for accessing screens as well as global configuration. */
export type App = PresentationElement & {
  __typename?: 'App';
  /**   Default brand image when no image is available. */
  defaultBrandImage?: Maybe<EditorialImage>;
  id: Scalars['String']['output'];
  /**   In App Messages configuration for the App Screen */
  inAppMessages?: Maybe<Array<Maybe<InAppMessage>>>;
  /**   Welcome screen to display information to new users of the apps. */
  introSplash?: Maybe<IntroSplash>;
  metaDescriptor?: Maybe<MetaDescriptor>;
  navigation?: Maybe<Navigation>;
  /**   The maximum number of times a user can skip the Onboarding flow before they are forced to proceed with the process. */
  productIntroMaxSkips?: Maybe<Scalars['Int']['output']>;
  /**
   *   The version of product intro currently available on the App.
   *  When a new version is released, client apps will show the product intro screens to all users (even those who have previously seen the screens).
   */
  productIntroVersion?: Maybe<Scalars['String']['output']>;
  screensPage: ScreensPage;
  title?: Maybe<Scalars['String']['output']>;
  /**   Configuration for Web platform only. */
  websiteConfiguration?: Maybe<WebsiteConfiguration>;
};

/**   Describes the entry point to the application and allows for accessing screens as well as global configuration. */
export type AppScreensPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**   Badges are set by editors in upstream systems. */
export type Badge = {
  __typename?: 'Badge';
  /**   formatted display text for showpages "Title - Description" */
  detailedLabel: Scalars['String']['output'];
  /**   Title of the badge, displayed on landing pages */
  label?: Maybe<Scalars['String']['output']>;
};

/**   Describes the base attributes of a Personalized Container which can be used to request for more information about the container */
export type BaseContainer = {
  __typename?: 'BaseContainer';
  id: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

/**   Describes the user's bookmarks (complete and incomplete) with raw data pertaining to the duration and progress of the bookmark. */
export type Bookmark = {
  __typename?: 'Bookmark';
  contentId: Scalars['String']['output'];
  lastModifiedTimestamp: Scalars['Long']['output'];
  mediaId: Scalars['String']['output'];
  /**   The point in secs from the start of the content where the bookmark was created */
  offset: Scalars['Int']['output'];
  /**   A value between 0 and 100 indicating the progress of the bookmark */
  progressPercentage?: Maybe<Scalars['Int']['output']>;
  /**   expanded accessibility reader label for the duration left to watch ("1 heure 15 minutes") */
  remainingTimeAccessibilityLabel?: Maybe<Scalars['String']['output']>;
  /**   duration left to watch in the content in seconds */
  remainingTimeInSecs?: Maybe<Scalars['Int']['output']>;
  /**   display label for the duration left to watch ("1 h 15 min") */
  remainingTimeLabel?: Maybe<Scalars['String']['output']>;
  /**   expanded accessibility reader label for the duration ("1 hour 15 minutes") */
  timeAccessibilityLabel: Scalars['String']['output'];
  /**   duration of the content in seconds */
  timeInSecs: Scalars['Int']['output'];
  /**   display label for the duration ("1h 15m") */
  timeLabel: Scalars['String']['output'];
};

/**   Describes a page of the user's bookmarks (complete and incomplete) with raw data pertaining to the duration and progress of the bookmark. */
export type BookmarkItemsPage = {
  __typename?: 'BookmarkItemsPage';
  bookmarks?: Maybe<Array<Bookmark>>;
  cursor?: Maybe<Scalars['String']['output']>;
};

export enum Breakpoint {
  L = 'L',
  M = 'M',
  S = 'S',
  Xl = 'XL',
  Xs = 'XS',
}

export enum ClientAction {
  DismissClose = 'DISMISS_CLOSE',
  SubscribeCraveads = 'SUBSCRIBE_CRAVEADS',
  SubscribeCravetv = 'SUBSCRIBE_CRAVETV',
  SubscribeFree = 'SUBSCRIBE_FREE',
  SubscribeStarz = 'SUBSCRIBE_STARZ',
}

export type CollectionItemsPage = {
  __typename?: 'CollectionItemsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<MetadataItem>>>;
};

/**   Describes the collection metadata including the type, thumbnail as well as the items within the collection. */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  collectionItemsPage: CollectionItemsPage;
  collectionType: CollectionMetadataType;
  id: Scalars['String']['output'];
  thumbnail?: Maybe<Image>;
  title: Scalars['String']['output'];
};

/**   Describes the collection metadata including the type, thumbnail as well as the items within the collection. */
export type CollectionMetadataCollectionItemsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollectionMetadataType {
  Collections = 'COLLECTIONS',
  Contents = 'CONTENTS',
  Medias = 'MEDIAS',
}

/**   Describes the flags on metadata that are computed and dynamic. See FlagType for the types of flags available. */
export type ComputedFlag = {
  __typename?: 'ComputedFlag';
  /**   This label contains additional information about the flag. If available, this will be localized. */
  detailedLabel?: Maybe<Scalars['String']['output']>;
  /**   The enum indicating the type of Computed Flag */
  flag: FlagType;
  /**   These are localized Strings to be displayed to FE user identifying the flag */
  label: Scalars['String']['output'];
};

/**   Describes the container configuration, style and the elements within. */
export type Container = PresentationElement & {
  __typename?: 'Container';
  /**   Container properties provided by Personalization team to provide the best experience for customers */
  configProperties: ContainerConfiguration;
  /**   Argument dcoCorrelationId is deprecated: Use HTTP 'x-dco-correlation-id' header, To be removed in March 2026 */
  containerItemsPage: ContainerItemsPage;
  displayTitle?: Maybe<Scalars['String']['output']>;
  displayType: ContainerDisplayType;
  id: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  style: ContainerDisplayStyle;
};

/**   Describes the container configuration, style and the elements within. */
export type ContainerContainerItemsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dcoCorrelationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ContainerConfiguration = {
  __typename?: 'ContainerConfiguration';
  brandedContainer: Scalars['Boolean']['output'];
  disableBadges: Scalars['Boolean']['output'];
  disableCount: Scalars['Boolean']['output'];
  disableDisplayTitle: Scalars['Boolean']['output'];
  featuredRowConfig?: Maybe<FeaturedConfiguration>;
  hideMediaTitle: Scalars['Boolean']['output'];
};

export enum ContainerDisplayStyle {
  Brandlink = 'BRANDLINK',
  Collection2x1 = 'COLLECTION2x1',
  Continuewatching = 'CONTINUEWATCHING',
  Episodic = 'EPISODIC',
  Extlink = 'EXTLINK',
  Live = 'LIVE',
  LiveUpcoming = 'LIVE_UPCOMING',
  Mylist = 'MYLIST',
  Poster = 'POSTER',
  Square = 'SQUARE',
  Teaser = 'TEASER',
  Top10 = 'TOP10',
}

export enum ContainerDisplayType {
  Grid = 'GRID',
  Shelf = 'SHELF',
}

export type ContainerItem =
  | CollectionMetadata
  | ContentMetadata
  | LinkButton
  | LinkImage
  | LinkText
  | LiveChannel
  | MediaMetadata
  | PromotionalTeaser;

/**   Describes the container items within a container as well as the total item count. */
export type ContainerItemsPage = {
  __typename?: 'ContainerItemsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<ContainerItem>>;
  /** @deprecated No longer used or maintained. Scheduled to be removed April, 2026 */
  totalItemsCount?: Maybe<Scalars['Int']['output']>;
};

/**   Describes Content Format */
export enum ContentFormat {
  Longform = 'LONGFORM',
  Shortform = 'SHORTFORM',
}

/**   Input for the type of Content Format */
export type ContentFormatRequest = {
  format?: InputMaybe<ContentFormat>;
};

export type ContentItemsPage = {
  __typename?: 'ContentItemsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<ContentMetadata>;
};

export type ContentLockDetails = {
  __typename?: 'ContentLockDetails';
  action: LockedCtaAction;
  ctaLabel?: Maybe<Scalars['String']['output']>;
};

/**   Describes metadata for playable video content */
export type ContentMetadata = {
  __typename?: 'ContentMetadata';
  badge?: Maybe<Badge>;
  broadcastDate?: Maybe<Scalars['String']['output']>;
  contentType: ContentMetadataType;
  /**   Optional as stream contents do not have duration */
  duration?: Maybe<Duration>;
  episodeNumber?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<ComputedFlag>>>;
  id: Scalars['String']['output'];
  /**   Identifies all the language features (locked and unlocked) available to the user */
  languageIndicators?: Maybe<Array<LanguageObject>>;
  /**   Identifies all the unlocked language features available to the user */
  languageMetadata?: Maybe<Array<LanguageObject>>;
  /**   lock details if content is locked */
  lockDetails?: Maybe<ContentLockDetails>;
  locked: Scalars['Boolean']['output'];
  maturityRatings?: Maybe<Array<Maybe<Dimension>>>;
  media: MediaMetadata;
  metadataImages?: Maybe<MetadataImages>;
  /**   The current in-window offline downloads availability for the content */
  offlineDownloadInfo?: Maybe<OfflineDownloadInfo>;
  parentalControl: ParentalControl;
  path: Scalars['String']['output'];
  ratingWarnings?: Maybe<Array<RatingWarning>>;
  seasonNumber?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum ContentMetadataType {
  Commercial = 'COMMERCIAL',
  Episode = 'EPISODE',
  Event = 'EVENT',
  Extra = 'EXTRA',
  Feature = 'FEATURE',
  Game = 'GAME',
  Highlight = 'HIGHLIGHT',
  News = 'NEWS',
  Promo = 'PROMO',
  Screener = 'SCREENER',
  Segment = 'SEGMENT',
  Song = 'SONG',
  Story = 'STORY',
  Stream = 'STREAM',
}

export type ContinueWatchingItemsPage = {
  __typename?: 'ContinueWatchingItemsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<ContentMetadata>;
};

/**   Describes the attributes and is used for People, Genres, Maturity, Ratings etc. */
export type Dimension = {
  __typename?: 'Dimension';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/**   Describes the duration metadata to the clients to display for video metadata. */
export type Duration = {
  __typename?: 'Duration';
  /**   Used to determine the timestamp when the bookmark was last updated */
  lastModifiedTimestamp?: Maybe<Scalars['Int']['output']>;
  progressPercentage?: Maybe<Scalars['Int']['output']>;
  remainingTimeAccessibilityLabel?: Maybe<Scalars['String']['output']>;
  remainingTimeInSecs?: Maybe<Scalars['Int']['output']>;
  remainingTimeLabel?: Maybe<Scalars['String']['output']>;
  timeAccessibilityLabel?: Maybe<Scalars['String']['output']>;
  timeInSecs: Scalars['Int']['output'];
  timeLabel?: Maybe<Scalars['String']['output']>;
};

/**
 *   Describes images curated editorially for presentation.
 *  Images may be defined by breakpoints. If breakpoint is empty, the same image is to be used for all screen sizes
 */
export type EditorialImage = {
  __typename?: 'EditorialImage';
  altText?: Maybe<Scalars['String']['output']>;
  breakpoint?: Maybe<Breakpoint>;
  subCopy?: Maybe<Scalars['String']['output']>;
  titleText?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/**   Describes the experiences which includes the SKU, content Policy SKU's and feature policies of a user account. */
export type Experience = {
  __typename?: 'Experience';
  contentPolicySKUs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**   SKU of experience for a given user account. */
  experienceSKU: Scalars['String']['output'];
  featurePolicies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
};

/**   Describes the list of experiences which includes the SKU, content Policy SKU's and feature policies, along with the cursor associated to next item, if available . */
export type ExperiencesPage = {
  __typename?: 'ExperiencesPage';
  cursor?: Maybe<Scalars['String']['output']>;
  experiences: Array<Experience>;
};

/**   Describes the generic feature element */
export type Feature = {
  __typename?: 'Feature';
  featureHeadline: Scalars['String']['output'];
  featureSummary: Scalars['String']['output'];
};

export type FeaturedBlock = {
  __typename?: 'FeaturedBlock';
  cta: LinkButton;
  headline?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Image>;
  oneLiner?: Maybe<Scalars['String']['output']>;
};

export type FeaturedConfiguration = {
  __typename?: 'FeaturedConfiguration';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImages?: Maybe<Array<Maybe<EditorialImage>>>;
  /**   Any one of featuredLink or featuredBlock will be available in the config */
  featuredBlock?: Maybe<FeaturedBlock>;
  /**   Any one of featuredLink or featuredBlock will be available in the config */
  featuredLink?: Maybe<LinkImage>;
  sponsorshipLabel?: Maybe<Scalars['String']['output']>;
};

export enum FlagType {
  Advertisement = 'ADVERTISEMENT',
  Expiring = 'EXPIRING',
  Free = 'FREE',
  Language = 'LANGUAGE',
  Upcoming = 'UPCOMING',
}

/**
 *   Web-only
 *  Describes the Gift element used within a Screen to provide user's with options to gift Crave
 */
export type Gift = {
  __typename?: 'Gift';
  backgroundImages?: Maybe<Array<Maybe<EditorialImage>>>;
  buttonText: Scalars['String']['output'];
  disclaimer?: Maybe<Scalars['String']['output']>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  giftOptions?: Maybe<Array<Maybe<GiftOption>>>;
  giftOptionsTitle: Scalars['String']['output'];
  giftTemplate?: Maybe<GiftTemplateType>;
  pageSummary: Scalars['String']['output'];
  pageSummaryLine2?: Maybe<Scalars['String']['output']>;
  panelImages?: Maybe<Array<Maybe<EditorialImage>>>;
};

/**
 *   Web-only
 *  Describes the Gift options in dollars available to the user
 */
export type GiftOption = {
  __typename?: 'GiftOption';
  displayTitle?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  promotionalText?: Maybe<Scalars['String']['output']>;
};

export enum GiftTemplateType {
  Default = 'DEFAULT',
  Holiday = 'HOLIDAY',
}

/**   Describes the element which includes the id and type */
export type IdAndType = {
  __typename?: 'IdAndType';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**   Describes an Image, including the image type, url and altText for the clients to render. */
export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']['output']>;
  imageType?: Maybe<ImageType>;
  url: Scalars['String']['output'];
};

export enum ImageType {
  Channellogo = 'CHANNELLOGO',
  Logo = 'LOGO',
  Poster = 'POSTER',
  Prtser = 'PRTSER',
  Prtsersm = 'PRTSERSM',
  Square = 'SQUARE',
  Thumbnail = 'THUMBNAIL',
  Thumbwide = 'THUMBWIDE',
}

/**   Describes the In App Message for user flow on App Screen */
export type InAppMessage = {
  __typename?: 'InAppMessage';
  dismissCta?: Maybe<MessageCta>;
  dismissMessageWindowInDays?: Maybe<Scalars['Int']['output']>;
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inAppMessageType: InAppMessageType;
  messageBody: Scalars['String']['output'];
  primaryCta: MessageCta;
};

export enum InAppMessageType {
  BmaSubscribe = 'BMA_SUBSCRIBE',
}

/**   Describes the welcoming screen to display information to users who have newly installed the apps. */
export type IntroSplash = PresentationElement & {
  __typename?: 'IntroSplash';
  brandLogo: EditorialImage;
  /**   The main image to be displayed with the element separated per platform by breakpoints */
  breakpointImages: Array<EditorialImage>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**   Used as a tag line offering additional / promotional text to display */
  promotionalCopy?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export enum Language {
  En = 'EN',
  Fr = 'FR',
}

/**   SUBTITLES is deprecated and will be removed in June 2026 */
export enum LanguageIndicator {
  Audio = 'AUDIO',
  Closedcaptions = 'CLOSEDCAPTIONS',
  Describedvideo = 'DESCRIBEDVIDEO',
  Subtitles = 'SUBTITLES',
  Ultrahd = 'ULTRAHD',
}

/**   Describes the language object, used when rendering elements that have multiple languages supported. Includes the indicator as well as the languages available. */
export type LanguageObject = {
  __typename?: 'LanguageObject';
  /**   The enum indicator identifying the feature available in the language */
  indicator: LanguageIndicator;
  /**   The localized display label for the indicator */
  indicatorLabel: Scalars['String']['output'];
  /**   The languages available for the indicator */
  languages: Array<PlaybackLanguage>;
};

/**  Link Element Types */
export type Link = {
  action: LinkAction;
  displayTitle: Scalars['String']['output'];
  openIn?: Maybe<LinkOpenIn>;
};

export type LinkAction =
  | BaseContainer
  | CollectionMetadata
  | Container
  | ContentMetadata
  | MediaMetadata
  | Screen
  | Url;

/**   Describes an in-App Content or external Web Link that is rendered as button */
export type LinkButton = Link &
  PresentationElement & {
    __typename?: 'LinkButton';
    action: LinkAction;
    buttonStyle?: Maybe<LinkButtonStyle>;
    displayTitle: Scalars['String']['output'];
    id: Scalars['String']['output'];
    openIn?: Maybe<LinkOpenIn>;
  };

export enum LinkButtonStyle {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

/**   Describes an in-App Content or external Web Link that is rendered as image */
export type LinkImage = Link &
  PresentationElement & {
    __typename?: 'LinkImage';
    action: LinkAction;
    displayTitle: Scalars['String']['output'];
    /**   Only available if LinkImageWidthStyle = DEFAULT */
    hoverImage?: Maybe<EditorialImage>;
    id: Scalars['String']['output'];
    /**   Only available if LinkImageWidthStyle = DEFAULT */
    image?: Maybe<EditorialImage>;
    /**   Up to 5 images (1 per breakpoint per language) entered by the content editors. Only available if LinkImageWidthStyle = FULL or CONTAINER. */
    imagesByBreakpoint?: Maybe<Array<Maybe<EditorialImage>>>;
    openIn?: Maybe<LinkOpenIn>;
    widthStyle?: Maybe<LinkImageWidthStyle>;
  };

export enum LinkImageWidthStyle {
  Container = 'CONTAINER',
  Default = 'DEFAULT',
  Full = 'FULL',
}

export enum LinkOpenIn {
  NewTab = 'NEW_TAB',
  SameTab = 'SAME_TAB',
}

/**   Describes an in-App Content or external Web Link that is rendered as text */
export type LinkText = Link &
  PresentationElement & {
    __typename?: 'LinkText';
    action: LinkAction;
    description?: Maybe<Scalars['String']['output']>;
    displayTitle: Scalars['String']['output'];
    id: Scalars['String']['output'];
    openIn?: Maybe<LinkOpenIn>;
  };

/**   Describes a Live element that can be setup in the CMS with groups */
export type Live = PresentationElement & {
  __typename?: 'Live';
  channelGroups: Array<LiveChannelGroup>;
  id: Scalars['String']['output'];
};

/**   Describes a Live channel that can contain one or more events */
export type LiveChannel = {
  __typename?: 'LiveChannel';
  channelId: Scalars['String']['output'];
  /**
   *   List of events scheduled on the channel. If parameters are to be sent in, both start and end time should be sent in
   *  Start and End time must be in ISO format (example: YYYY-MM-DDThh:mm:ssZ), within a 24 hour period
   *  Start time cannot be more than 1 day in the past and End time cannot be more than 14 days in the future
   */
  events?: Maybe<Array<LiveEvent>>;
  /**   Represents the channel stream as defined in the VCMS */
  streamContent: ContentMetadata;
};

/**   Describes a Live channel that can contain one or more events */
export type LiveChannelEventsArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/**   Describes a Live channel group that can contain one or more channels */
export type LiveChannelGroup = {
  __typename?: 'LiveChannelGroup';
  /**   List of channels in the group */
  channels: Array<LiveChannel>;
  groupId: Scalars['String']['output'];
  /**   Localized Channel Group Name */
  groupName: Scalars['String']['output'];
};

/**   Describes the live events for a channel. Shows events scheduled 4 hours in the past and 4 hours in the future from the current date. */
export type LiveEvent = {
  __typename?: 'LiveEvent';
  /**   The event's end time in UTC */
  endTimeUtc: Scalars['String']['output'];
  /**   The event's long description */
  eventDescription?: Maybe<Scalars['String']['output']>;
  /**   The event's Id */
  eventId: Scalars['String']['output'];
  /**   The thumbnail image to be shown on the FE for this event */
  eventImage?: Maybe<Image>;
  /**   The Live Event Page information for this event */
  eventPage?: Maybe<LiveEventPage>;
  /**   Indicates the scheduling of the event in terms of time */
  eventScheduleType?: Maybe<LiveEventScheduleType>;
  /**   The event's short description */
  eventShortDescription?: Maybe<Scalars['String']['output']>;
  /**   The formatted season/episode info for shows and release year for movies, when available */
  eventSubTitle?: Maybe<Scalars['String']['output']>;
  /**   The event's name */
  eventTitle: Scalars['String']['output'];
  /**   Indicates if the event is scheduled on a bonus stream */
  isBonusEvent?: Maybe<Scalars['Boolean']['output']>;
  /**
   *   Identifies if the event is being broadcasted live
   * @deprecated use eventScheduleType instead. To be removed Jun 2026.
   */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /**   Indicators that identify possible extra information about this event */
  qualifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**   The event's start time in UTC */
  startTimeUtc: Scalars['String']['output'];
  /**   Indicates a cross-system identifier that helps identify the event across the ecosystem */
  tmsId: Scalars['String']['output'];
  /**   Represents the event item as defined in the VCMS */
  vodContent?: Maybe<ContentMetadata>;
};

/**   Describes the page that has live event information along with other details */
export type LiveEventPage = {
  __typename?: 'LiveEventPage';
  primaryCta?: Maybe<Scalars['String']['output']>;
};

export enum LiveEventScheduleType {
  Live = 'LIVE',
  Upcoming = 'UPCOMING',
}

/**
 *   SIGN_IN: Shown to unauthenticated users for locked media on all platforms. On Web, also shown for partially locked, non season based media
 *  SIGN_IN_FREE: Shown only on Web to unauthenticated users for locked media when media is fully free to watch
 *  SUBSCRIBE: @deprecated(reason="Unused. Scheduled for removal, April 2026")
 *  WAYSTOWATCH: Shown to authenticated users for locked media on all platforms. On Web, also shown to unauthenticated users for partially locked, season based media
 */
export enum LockedCtaAction {
  SignIn = 'SIGN_IN',
  SignInFree = 'SIGN_IN_FREE',
  Subscribe = 'SUBSCRIBE',
  Waystowatch = 'WAYSTOWATCH',
}

/**   Describes a visual element displayed as a set of image logos for sponsorships and social shares. */
export type LogoBar = {
  __typename?: 'LogoBar';
  displayTitle?: Maybe<Scalars['String']['output']>;
  layoutType: LogoBarLayoutType;
  /**   Social type can have 5 logos, Primary can have 3 and Secondary can have upto 12 logos in a single Logo Bar */
  logos: Array<LinkImage>;
};

export enum LogoBarLayoutType {
  PrimarySponsorship = 'PRIMARY_SPONSORSHIP',
  SecondarySponsorship = 'SECONDARY_SPONSORSHIP',
  Social = 'SOCIAL',
}

/**   Describes the Marketing element which contains a list of marketing panels */
export type Marketing = {
  __typename?: 'Marketing';
  panels: Array<MarketingPanel>;
};

/**   Describes the bundles when the panel time is bundles */
export type MarketingBundle = {
  __typename?: 'MarketingBundle';
  bundleCta?: Maybe<LinkButton>;
  bundleHeadline: Scalars['String']['output'];
  bundleImages: Array<Maybe<EditorialImage>>;
  bundleLearnMoreCta?: Maybe<LinkText>;
  bundleLogo?: Maybe<EditorialImage>;
};

/**   Describes the marketing panels used to render the marketing page */
export type MarketingDevice = {
  __typename?: 'MarketingDevice';
  deviceHeadline: Scalars['String']['output'];
  deviceIcon?: Maybe<EditorialImage>;
  deviceList: Array<Scalars['String']['output']>;
};

/**   Describes the subscription element for advertising the features of the product */
export type MarketingPanel = {
  __typename?: 'MarketingPanel';
  /**   Only available when panelType is BUNDLES */
  bundles?: Maybe<Array<Maybe<MarketingBundle>>>;
  /**   Only available when panelType is DEVICES */
  devices?: Maybe<Array<Maybe<MarketingDevice>>>;
  /**   Only available when panelType is FAQ */
  faq?: Maybe<Array<Maybe<Feature>>>;
  panelByline?: Maybe<Scalars['String']['output']>;
  panelCta?: Maybe<LinkButton>;
  panelFootnote?: Maybe<Scalars['String']['output']>;
  panelHeadline: Scalars['String']['output'];
  panelImages?: Maybe<Array<Maybe<EditorialImage>>>;
  panelSummary?: Maybe<Scalars['String']['output']>;
  panelType: MarketingPanelType;
};

/**   Describes the types of marketing panels for the marketing element */
export enum MarketingPanelType {
  Bundles = 'BUNDLES',
  Default = 'DEFAULT',
  Devices = 'DEVICES',
  Faq = 'FAQ',
  Featured = 'FEATURED',
  Plans = 'PLANS',
}

export enum Maturity {
  Adult = 'ADULT',
  KidO = 'KID_O',
  KidPre = 'KID_PRE',
  KidY = 'KID_Y',
  Teen = 'TEEN',
}

/**   Describes the Actions on a Media so the client teams can render the action logic to the customer. */
export type MediaAction = {
  __typename?: 'MediaAction';
  actionType: MediaActionType;
  displayLabel: Scalars['String']['output'];
  /**   Only if MediaActionType is TRAILER */
  promo?: Maybe<ContentMetadata>;
  /**   Only for editorial actions */
  url?: Maybe<Scalars['String']['output']>;
};

export enum MediaActionType {
  Casting = 'CASTING',
  Contest = 'CONTEST',
  Download = 'DOWNLOAD',
  Languages = 'LANGUAGES',
  Mylist = 'MYLIST',
  News = 'NEWS',
  Podcast = 'PODCAST',
  Recipe = 'RECIPE',
  Schedule = 'SCHEDULE',
  Share = 'SHARE',
  Ticket = 'TICKET',
  Trailer = 'TRAILER',
  Vote = 'VOTE',
}

/**   Describes the metadata for a Media. Allows the clients to get information to render a show page to the customers. */
export type MediaMetadata = {
  __typename?: 'MediaMetadata';
  badges?: Maybe<Array<Badge>>;
  /**   The latest content that the user played in this media */
  bookmark?: Maybe<ContentMetadata>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<MediaPage>;
  /**   This field represents 3 scenarios, in order: The featured content curated in the CMS or the first playable content in the media for the user or the first available content in the media (This content could be locked for the user). */
  firstContent?: Maybe<ContentMetadata>;
  flags?: Maybe<Array<Maybe<ComputedFlag>>>;
  genres?: Maybe<Array<Maybe<Dimension>>>;
  id: Scalars['String']['output'];
  isInWatchList: Scalars['Boolean']['output'];
  /**   set to true when all long form contents associated to this media are locked to the user */
  locked: Scalars['Boolean']['output'];
  maturityRatings?: Maybe<Array<Maybe<Dimension>>>;
  mediaType: MediaMetadataType;
  metadataImages?: Maybe<MetadataImages>;
  originalLanguage?: Maybe<Dimension>;
  originatingNetworkLogo?: Maybe<Image>;
  owner?: Maybe<Scalars['String']['output']>;
  parentalControl: ParentalControl;
  path: Scalars['String']['output'];
  productionYear?: Maybe<Scalars['String']['output']>;
  ratingWarnings: Array<RatingWarning>;
  seasons?: Maybe<Array<SeasonMetadata>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum MediaMetadataType {
  Campaign = 'CAMPAIGN',
  Linear = 'LINEAR',
  Movie = 'MOVIE',
  Music = 'MUSIC',
  News = 'NEWS',
  Series = 'SERIES',
  Special = 'SPECIAL',
  Sports = 'SPORTS',
}

/**   This type includes all the additional information needed to be displayed on the show page for a Media */
export type MediaPage = {
  __typename?: 'MediaPage';
  accessRack?: Maybe<AccessRack>;
  actions: Array<MediaAction>;
  cast?: Maybe<Array<Maybe<People>>>;
  /**   SEO fields */
  metaDescriptor?: Maybe<MetaDescriptor>;
  primarySponsorship?: Maybe<LogoBar>;
  /**   List of LinkImage elements for banners that are used to promote upcoming shows and events on a media page. limit of 4 */
  promotionalBanners?: Maybe<Array<LinkImage>>;
  secondarySponsorship?: Maybe<LogoBar>;
  socialBar?: Maybe<LogoBar>;
  tabs?: Maybe<Array<Maybe<MediaTab>>>;
};

export type MediaPageElement =
  | Container
  | ContentMetadata
  | LinkImage
  | LogoBar
  | MediaMetadata;

/**
 *   Describes the Media Tab for the client teams to render on Media Pages.
 *  This allows editors to customize the content that is within the tabs on the showpage.
 */
export type MediaTab = {
  __typename?: 'MediaTab';
  id: Scalars['String']['output'];
  tabContents?: Maybe<Array<MediaPageElement>>;
  tabLabel: Scalars['String']['output'];
  tabType: MediaTabType;
};

export enum MediaTabType {
  Editorial = 'EDITORIAL',
  Longform = 'LONGFORM',
  PapiYml = 'PAPI_YML',
  Shortform = 'SHORTFORM',
}

export type MessageCta = {
  __typename?: 'MessageCta';
  ctaAction: ClientAction;
  messageLabel: Scalars['String']['output'];
};

/**   Describes the meta description for the client team to render to the customer. This includes descriptors for SEO keywords, app title and images. */
export type MetaDescriptor = PresentationElement & {
  __typename?: 'MetaDescriptor';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Maybe<EditorialImage>>>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MetadataImages = {
  __typename?: 'MetadataImages';
  /**   Image Type reserved to be used as the Live channel logo */
  channelLogo?: Maybe<Image>;
  logo?: Maybe<Image>;
  poster?: Maybe<Image>;
  promoTeaserLarge?: Maybe<Image>;
  promoTeaserSmall?: Maybe<Image>;
  square?: Maybe<Image>;
  thumbnail?: Maybe<Image>;
};

export type MetadataItem = CollectionMetadata | ContentMetadata | MediaMetadata;

export enum MetadataType {
  Content = 'CONTENT',
  Media = 'MEDIA',
}

export type MetadataTypeInput = {
  type: MetadataType;
};

export type MyListItemsPage = {
  __typename?: 'MyListItemsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<MediaMetadata>>;
};

/**   Describes the navigation rendered at App level. This includes the copyright, as well as social and corporate links. */
export type Navigation = PresentationElement & {
  __typename?: 'Navigation';
  copyright?: Maybe<Scalars['String']['output']>;
  corporateLinks?: Maybe<Array<Maybe<LinkText>>>;
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  navigationLinks?: Maybe<Array<Maybe<NavigationLink>>>;
  socialLinks?: Maybe<Array<Maybe<LinkImage>>>;
};

/**   Describes the Navigation of type Link for the clients to render. Includes the type, the logo type and the actual Link to render. */
export type NavigationLink = {
  __typename?: 'NavigationLink';
  link?: Maybe<Link>;
  logoType?: Maybe<NavigationLogoType>;
  tokenType: NavigationToken;
};

export enum NavigationLogoType {
  CustomCanadaEn = 'CUSTOM_CANADA_EN',
  CustomCanadaFr = 'CUSTOM_CANADA_FR',
  Home = 'HOME',
  Kids = 'KIDS',
  Live = 'LIVE',
  Movies = 'MOVIES',
  News = 'NEWS',
  None = 'NONE',
  Shows = 'SHOWS',
  Sports = 'SPORTS',
}

/**
 *   This Enum describes the type of Navigation options available.
 *  Link is used to describe that the navigation item should be rendered as a link type.
 *  All the other types identify client-handled logic.
 */
export enum NavigationToken {
  LanguageSettings = 'LANGUAGE_SETTINGS',
  Link = 'LINK',
  MyCravings = 'MY_CRAVINGS',
  Separator = 'SEPARATOR',
  ShowSearchIcon = 'SHOW_SEARCH_ICON',
  ShowUserProfileIcon = 'SHOW_USER_PROFILE_ICON',
}

export type OfflineDownloadInfo = {
  __typename?: 'OfflineDownloadInfo';
  /**  indicates if download is allowed */
  allowed: Scalars['Boolean']['output'];
  /**   Provides language based information for the download. */
  downloadPackages?: Maybe<Array<Maybe<OfflineDownloadPackage>>>;
};

export type OfflineDownloadPackage = {
  __typename?: 'OfflineDownloadPackage';
  contentPackageId: Scalars['String']['output'];
  destinationId: Scalars['Int']['output'];
  endCreditOffset?: Maybe<Scalars['Int']['output']>;
  /**   Indicates when the download constraint ends (the earlier date between constraint and schedule end dates) */
  endDate?: Maybe<Scalars['String']['output']>;
  /**   With multi-language contents, more than one language can be present */
  languages?: Maybe<Array<Maybe<PlaybackLanguage>>>;
};

/**   Describes the maturity controls (aligns to AGVOT ratings) indicating if the user profile is allowed to watch contents */
export type ParentalControl = {
  __typename?: 'ParentalControl';
  /**   only available if locked = true and meant to be shown on container items */
  containerDisplayMessage?: Maybe<Scalars['String']['output']>;
  /**   only available if locked = true and meant to be shown on the show page */
  displaySubTitle?: Maybe<Scalars['String']['output']>;
  /**   only available if locked = true and meant to be shown on the show page */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /**   indicates if the metadata item is rated outside of the user profile's maturity rating */
  locked: Scalars['Boolean']['output'];
};

/**   Describes the metadata for the people associated to a Media Page. Used for Cast Members, Directors etc. */
export type People = {
  __typename?: 'People';
  members: Array<Dimension>;
  role: Scalars['String']['output'];
};

export type PlaybackLanguage = {
  __typename?: 'PlaybackLanguage';
  displayTitle: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  /**   Identifies if the user can play the content using this language and their experiences */
  locked: Scalars['Boolean']['output'];
};

export type PresentationElement = {
  id: Scalars['String']['output'];
};

export type ProductInfoScreen = {
  __typename?: 'ProductInfoScreen';
  continueButtonCopy?: Maybe<Scalars['String']['output']>;
  image: EditorialImage;
  skipButtonCopy?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProductIntro = {
  __typename?: 'ProductIntro';
  /**   Defines 1-4 screens that will show the user what the App's product represents. */
  screens: Array<ProductInfoScreen>;
};

export type ProductOnboarding = {
  __typename?: 'ProductOnboarding';
  onboardingCollection: Container;
};

/**   Describes the teaser element used within a Container to promote the brand's latest and greatest content */
export type PromotionalTeaser = {
  __typename?: 'PromotionalTeaser';
  /**   Describes a max of 2 buttons curated editorially and provided from the Composer */
  buttons?: Maybe<Array<LinkButton>>;
  /**
   *   Deprecated field. Use buttons instead. To be removed in June 2026.
   * @deprecated Use buttons instead. To be removed in June 2026
   */
  cta?: Maybe<PromotionalTeaserCta>;
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**   Defines the promotional images for the teaser, which can be rendered differently based on breakpoints. This is curated editorially and provided from the Composer. */
  images?: Maybe<Array<Maybe<Image>>>;
  /**
   *   Deprecated field. Value will always be null. Use promotedItem instead. To be removed in June 2026.
   * @deprecated Use promotedItem instead. Value will always be null. To be removed in June 2026
   */
  item?: Maybe<MetadataItem>;
  /**   Describes the item being promoted. */
  promotedItem?: Maybe<LinkAction>;
  /**   Describes the Primary Sponsorship for the Promotional Teaser */
  sponsorship?: Maybe<LogoBar>;
  summary?: Maybe<Scalars['String']['output']>;
  /**   Editorially driven tune-in badge */
  tuneInInfo?: Maybe<Scalars['String']['output']>;
};

export type PromotionalTeaserCta = {
  __typename?: 'PromotionalTeaserCTA';
  action: PromotionalTeaserCtaAction;
  label?: Maybe<Scalars['String']['output']>;
};

export enum PromotionalTeaserCtaAction {
  PlayerPage = 'PLAYER_PAGE',
  ShowPage = 'SHOW_PAGE',
  SignIn = 'SIGN_IN',
}

export type Query = {
  __typename?: 'Query';
  /**   Entry point query to the application. Used to query for app metadata including Title, screens, navigation and configuration. */
  app?: Maybe<App>;
  /**   to be used for landing page use cases. The ids parameter must not exceed 100 ids per request. */
  bookmarksByContentIds?: Maybe<Array<Bookmark>>;
  /**   Returns the user's bookmarks (complete and incomplete) for a given media id (mandatory) and content format (optional) */
  bookmarksByMediaIdItemsPage: BookmarkItemsPage;
  /**   Returns the user's bookmarks (complete and incomplete) for a given season id (mandatory) and content format (optional) */
  bookmarksBySeasonIdItemsPage: BookmarkItemsPage;
  /**
   *   Returns the Content, Media and Collection items in the selected package of the AXIS collections. Same Pagination attributes are applied to all the Collections.
   *  This field is now limited and must not exceed 30 ids
   */
  collections?: Maybe<Array<CollectionMetadata>>;
  /**   Query to return the container element by a given ID. Returns the metadata as well as elements contained with the container. */
  container?: Maybe<Container>;
  /**
   *   Query to return a list of Contents given a list of content ids
   *  This field is now limited and must not exceed 30 ids
   */
  contents?: Maybe<Array<ContentMetadata>>;
  /**   Deprecated and will be removed in April 2026. Use contentsByMediaIdItemsPage Limited to 200 items returned */
  contentsByMediaId?: Maybe<Array<ContentMetadata>>;
  /**   Query contents by season given a media id. Returns a page with a list of Contents associated to a media that is within window. */
  contentsByMediaIdItemsPage: ContentItemsPage;
  /**   Deprecated and will be removed in April 2026. Use contentsBySeasonIdItemsPage. */
  contentsBySeasonId?: Maybe<Array<ContentMetadata>>;
  /**   Query contents by season given a season id. Returns a page with a list of Contents associated to a season that is in window. */
  contentsBySeasonIdItemsPage: ContentItemsPage;
  /**   to be used for landing page use cases. The ids parameter must not exceed 100 ids per request. */
  continueWatchingByMediaIds?: Maybe<Array<Bookmark>>;
  /**   Returns content metadata which was part of a media the user is watching sorted by most recently watched */
  continueWatchingItemsPage: ContinueWatchingItemsPage;
  /**   Returns In App Messages to be displayed on the App Screen. These messages are curated editorially and can be used to communicate specific user flow. */
  inAppMessages?: Maybe<Array<InAppMessage>>;
  /**   Query to return the ID and metadata type for an element by URL path */
  itemByPath?: Maybe<IdAndType>;
  /**   Query Live channel event by event id. Returns a LiveChannel including Live event details for the events page. */
  liveChannelEvent?: Maybe<LiveChannel>;
  /**   Query Live channel group by group id. Returns a LiveChannelGroup including Live events schedules. */
  liveChannelGroup?: Maybe<LiveChannelGroup>;
  /**   Query to return a list of tabs on a show page, given a list of tab Ids and a media Id */
  mediaTabs?: Maybe<Array<MediaTab>>;
  /**
   *   Query to return a list of Medias given a list of ids.
   *  This field is now limited and must not exceed 30 ids
   */
  medias?: Maybe<Array<MediaMetadata>>;
  /**   Query user's watch list based on profile id of the user. Returns a page with a list of Medias */
  myListItemsPage: MyListItemsPage;
  /**   Returns the onboarding experience mapping/lineup fetched from PAPI and hydrates the first available container in the lineup */
  onboarding?: Maybe<ProductOnboarding>;
  /**   Returns an App's Product Introductory screens that kickstarts a user's Onboarding process. */
  productIntro?: Maybe<ProductIntro>;
  /**   Query to return a particular screen by id. Returns metadata for the screen as well as objects contained within a screen. */
  screen?: Maybe<Screen>;
  /**   Search endpoint to search by keyword and collection type as well as product. Returns a SearchResult containing results. */
  search?: Maybe<SearchResult>;
  /**
   *   Query to return a list of Seasons given a list of season ids.
   *  This field is now limited and must not exceed 30 ids
   */
  seasons?: Maybe<Array<SeasonMetadata>>;
  userAccountInfo?: Maybe<UserAccount>;
  /**
   *   Query to return a paginated list of the user's watch history items.
   *  If not provided, limit is defaulted to 30 items per page.
   */
  watchHistoryItemsPage: WatchHistoryItemsPage;
  /**   Query Ways to watch modal */
  waysToWatch?: Maybe<WaysToWatchModal>;
};

export type QueryAppArgs = {
  id: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryBookmarksByContentIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  sessionContext: SessionContext;
};

export type QueryBookmarksByMediaIdItemsPageArgs = {
  contentFormat?: InputMaybe<ContentFormatRequest>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryBookmarksBySeasonIdItemsPageArgs = {
  contentFormat?: InputMaybe<ContentFormatRequest>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryCollectionsArgs = {
  ids: Array<Scalars['String']['input']>;
  sessionContext: SessionContext;
};

export type QueryContainerArgs = {
  id: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryContentsArgs = {
  ids: Array<Scalars['String']['input']>;
  sessionContext: SessionContext;
};

export type QueryContentsByMediaIdArgs = {
  contentFormat?: InputMaybe<ContentFormatRequest>;
  id: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryContentsByMediaIdItemsPageArgs = {
  contentFormat?: InputMaybe<ContentFormatRequest>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryContentsBySeasonIdArgs = {
  contentFormat?: InputMaybe<ContentFormatRequest>;
  id: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryContentsBySeasonIdItemsPageArgs = {
  contentFormat?: InputMaybe<ContentFormatRequest>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryContinueWatchingByMediaIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  sessionContext: SessionContext;
};

export type QueryContinueWatchingItemsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryInAppMessagesArgs = {
  appId: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryItemByPathArgs = {
  path: Scalars['String']['input'];
};

export type QueryLiveChannelEventArgs = {
  eventId: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryLiveChannelGroupArgs = {
  groupId: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryMediaTabsArgs = {
  ids: Array<Scalars['String']['input']>;
  mediaId: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryMediasArgs = {
  ids: Array<Scalars['String']['input']>;
  sessionContext: SessionContext;
};

export type QueryMyListItemsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryOnboardingArgs = {
  appId: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryProductIntroArgs = {
  appId: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QueryScreenArgs = {
  id: Scalars['String']['input'];
  sessionContext: SessionContext;
};

export type QuerySearchArgs = {
  searchRequest: SearchRequest;
  sessionContext: SessionContext;
};

export type QuerySeasonsArgs = {
  ids: Array<Scalars['String']['input']>;
  sessionContext: SessionContext;
};

export type QueryWatchHistoryItemsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionContext: SessionContext;
};

export type QueryWaysToWatchArgs = {
  metadataId: Scalars['String']['input'];
  metadataType: MetadataTypeInput;
  sessionContext: SessionContext;
};

/**   Describe the rating warnings associated to the Media and Content with their corresponding English and French display labels */
export type RatingWarning = {
  __typename?: 'RatingWarning';
  code: Scalars['String']['output'];
  displayLabelEn?: Maybe<Scalars['String']['output']>;
  displayLabelFr?: Maybe<Scalars['String']['output']>;
};

/**   Describes the elements to present to the user as well as the navigation to show and configuration */
export type Screen = PresentationElement & {
  __typename?: 'Screen';
  channelName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metaDescriptor?: Maybe<MetaDescriptor>;
  navigation?: Maybe<ScreenNavigation>;
  path: Scalars['String']['output'];
  renderType: ScreenRenderType;
  /**   Argument dcoCorrelationId is deprecated: Use HTTP 'x-dco-correlation-id' header, To be removed in March 2026 */
  screenContentsPage: ScreenContentsPage;
  screenPageType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/**   Describes the elements to present to the user as well as the navigation to show and configuration */
export type ScreenScreenContentsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dcoCorrelationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScreenContent =
  | AdElement
  | Container
  | Gift
  | Image
  | LinkButton
  | LinkImage
  | Live
  | Marketing
  | TextArea;

export type ScreenContentsPage = {
  __typename?: 'ScreenContentsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  dcoCorrelationId?: Maybe<Scalars['String']['output']>;
  screenContents: Array<ScreenContent>;
};

/**   Describes the navigation rendered at Screen level. */
export type ScreenNavigation = {
  __typename?: 'ScreenNavigation';
  displayTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<EditorialImage>;
  navigationLinks: Array<LinkText>;
};

export enum ScreenRenderType {
  Finite = 'FINITE',
  Infinite = 'INFINITE',
}

export type ScreensPage = {
  __typename?: 'ScreensPage';
  cursor?: Maybe<Scalars['String']['output']>;
  screens: Array<Screen>;
};

export enum SearchCollectionType {
  Articles = 'ARTICLES',
  Contents = 'CONTENTS',
  Medias = 'MEDIAS',
}

/**   Input for the search request when querying for search results. */
export type SearchRequest = {
  /**   Determine the type / expected items (Medias, Contents, Articles) */
  collection?: InputMaybe<SearchCollectionType>;
  /**   Defaults to 1, if not provided or set to less than 1 */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /**   Defaults to 30, if not provided or set to greater than 30 */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
};

/**   Describes the search results (MediaMetadata only) from the Search API for the given query terms */
export type SearchResult = {
  __typename?: 'SearchResult';
  found?: Maybe<Scalars['Int']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  mediaResults?: Maybe<Array<Maybe<MediaMetadata>>>;
  pageSize?: Maybe<Scalars['Int']['output']>;
};

/**
 *   Describes the metadata for a Season to be rendered. This allows the client to describe a season
 *  in terms of title, season number, purchase options and flags. This allows customers to access a season, and, also
 *  provides the purchase options if they are not subscribed.
 */
export type SeasonMetadata = {
  __typename?: 'SeasonMetadata';
  episodesCount: Scalars['Int']['output'];
  flags?: Maybe<Array<Maybe<ComputedFlag>>>;
  id: Scalars['String']['output'];
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/**   Input to provide session context (Client and user info) used in queries to the RTE. */
export type SessionContext = {
  userLanguage: Language;
  userMaturity: Maturity;
};

/**   Describes the TextArea element. Allowing content editors to add text to a screen. */
export type TextArea = PresentationElement & {
  __typename?: 'TextArea';
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Url = {
  __typename?: 'URL';
  action?: Maybe<ClientAction>;
  link?: Maybe<Scalars['String']['output']>;
};

export type UpsellProduct = {
  __typename?: 'UpsellProduct';
  isAddOn: Scalars['Boolean']['output'];
  productInfo?: Maybe<Scalars['String']['output']>;
  productLogoId: Scalars['String']['output'];
  productLogoUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  productPurchaseText?: Maybe<Scalars['String']['output']>;
};

/**   Describes the user experiences of an account */
export type UserAccount = {
  __typename?: 'UserAccount';
  /**   Identifier indicating if the user is an admin user */
  adminProfile: Scalars['Boolean']['output'];
  experiencesPage: ExperiencesPage;
};

/**   Describes the user experiences of an account */
export type UserAccountExperiencesPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**   Describes the user watch history for an authenticated user. */
export type WatchHistoryContent = {
  __typename?: 'WatchHistoryContent';
  /**   Localized accessible label which allows the display label to be read out. */
  accessibleDisplayLabel: Scalars['String']['output'];
  contentId: Scalars['String']['output'];
  /**   Epoch secs when the content was first watched */
  createdDateSecs: Scalars['Long']['output'];
  /**   For non-seasonal content, this will be the production year. For seasonal content, this will be localized content title with Season and Episode numbers added. */
  displayLabel: Scalars['String']['output'];
  mediaId: Scalars['String']['output'];
  /**  Localized media title */
  mediaName: Scalars['String']['output'];
  /**   Path to the media page */
  mediaPath?: Maybe<Scalars['String']['output']>;
};

/**  Describes a single page of the user's watch history items. A cursor is returned if there are more items to be fetched. */
export type WatchHistoryItemsPage = {
  __typename?: 'WatchHistoryItemsPage';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<WatchHistoryContent>>;
};

export enum WaysToWatchAction {
  ChangeDevice = 'CHANGE_DEVICE',
  Info = 'INFO',
  ManageSubscription = 'MANAGE_SUBSCRIPTION',
  NewSubscription = 'NEW_SUBSCRIPTION',
  Subscribe = 'SUBSCRIBE',
  TvProvider = 'TV_PROVIDER',
  UpgradeSubscription = 'UPGRADE_SUBSCRIPTION',
}

/**   Describes the Ways to Watch modal for a user trying to access locked content/media. */
export type WaysToWatchModal = {
  __typename?: 'WaysToWatchModal';
  action: WaysToWatchAction;
  /**   Only available on WAYSTOWATCH CTA Type */
  bduChannels?: Maybe<Array<Maybe<UpsellProduct>>>;
  /**
   *   CTA copy used to show a link to the user which they can use to sign in with their TV Provider.
   *  Available for a DTC user if BDUChannels are not empty or for a BDU user if their link is expired
   */
  bduLinkProviderCta?: Maybe<Scalars['String']['output']>;
  /**   Only available on WAYSTOWATCH CTA Type */
  dtcProducts?: Maybe<Array<Maybe<UpsellProduct>>>;
  infoMessageSubTitle?: Maybe<Scalars['String']['output']>;
  infoMessageTitle?: Maybe<Scalars['String']['output']>;
  /**   The localized name of the metadata item requested. This will be used to replace the placeholder in the modal copy */
  metadataTitle: Scalars['String']['output'];
  modalSubtitle?: Maybe<Scalars['String']['output']>;
  modalTitle: Scalars['String']['output'];
  /**   Copy shown in the Secondary section, currently only available if BDUChannels are not empty */
  secondarySubtitle?: Maybe<Scalars['String']['output']>;
  /**   Set to true when the user is BDU and their link is expired */
  showRelinkCta: Scalars['Boolean']['output'];
};

/**   Describes the configuration applicable to the web application clients. Provides details on the what to display on 404 pages and related applications. */
export type WebsiteConfiguration = PresentationElement & {
  __typename?: 'WebsiteConfiguration';
  content404?: Maybe<Array<Maybe<Container>>>;
  id: Scalars['String']['output'];
  relatedApps?: Maybe<Array<Maybe<App>>>;
};
